import { useSelector } from 'react-redux';
import { RootState } from '../../Store';

export const useIsScopeClosed = (scope?: string): boolean => {
    if (scope === undefined) {
        return false;
    }

    return useSelector<RootState, boolean>(state => state.scopes.scopes.includes(scope));
};
